import { toNote } from '@/lib/link'
import { generateBech32IdFromATag, tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function WikiRedirectPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const dTag = useMemo(() => event.tags.find(tagNameEquals('d'))?.[1], [event])
  const aTag = useMemo(() => event.tags.find(tagNameEquals('a')), [event])
  const targetIdentifier = aTag ? aTag[1].split(':')[2] : undefined
  const targetNaddr = useMemo(() => (aTag ? generateBech32IdFromATag(aTag) : undefined), [aTag])

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Redirect')}] <span className="italic pr-0.5">{dTag}</span>
      {targetIdentifier && (
        <>
          {' → '}
          <a href={toNote(event)} onClick={(e) => e.preventDefault()} className="italic pr-0.5">
            {targetIdentifier || targetNaddr}
          </a>
        </>
      )}
    </div>
  )
}
